import {canBePickedUp} from "../libraries/utils";
import {generateRandomNumber} from "../libraries/globalTemplateSpecific/bm100/utils";
import {mapGetters} from "vuex";
import appConfig from "../appconfig";
import MysteryBoxProvider from "../providers/MysteryBoxProvider";
import {SET_VOUCHER_VIRTUAL_ORDER_ID} from "../store/mutation-types";
import * as mutationTypes from "../store/mutation-types";

const MYSTERY_BOX_LABELS = Object.freeze({
	MYSTERY_BOX_RANDOM_ACT_OF_KINDNESS: "MysteryBoxRandomActOfKindness",
	MYSTERY_BOX_LOWER: "MysteryBoxLower",
	MYSTERY_BOX_HIGHER: "MysteryBoxHigher"
});

export default {
	computed: {
		...mapGetters([
			"priceRules",
			"productCatalog",
			"tenantSettings",
			"tenantSpecificData",
			"selections",
			"mysteryBoxModalState",
			"isSubscribed",
			"applicationUserLoggedIn",
			"customerDetails",
			"globalSelectedShop"
		]),
		mysteryBoxSettings() {
			return this.tenantSettings.mysteryBox || {};
		},
		getMysteryBoxPriceRuleLabel() {
			if(this.globalSelectedShop.shopOptions.enableMysteryBoxRandomActOfKindness) {
				return MYSTERY_BOX_LABELS.MYSTERY_BOX_RANDOM_ACT_OF_KINDNESS;
			}
			return this.totalPrice < (this.mysteryBoxSettings.mysteryBoxPriceThreshold || 0)
				? MYSTERY_BOX_LABELS.MYSTERY_BOX_LOWER
				: MYSTERY_BOX_LABELS.MYSTERY_BOX_HIGHER;
		},
		checkMysteryBoxCriteria() {
			if(this.globalSelectedShop.isOpeningLaterToday) {
				return false;
			}
			if(this.globalSelectedShop.shopOptions.enableMysteryBoxRandomActOfKindness && this.globalSelectedShop.shopOptions.enableMysteryBox) {
				return false;
			}
			if(
				this.globalSelectedShop.shopOptions.enableMysteryBoxRandomActOfKindness
				&& !this.selections.find(s => s.mysteryBoxAppliedVoucherId)
				&& this.mysteryBoxModalState
				&& this.cartProducts.length
			) {
				return true;
			}
			return this.globalSelectedShop.shopOptions.enableMysteryBox
				&& !this.selections.find(s => s.mysteryBoxAppliedVoucherId)
				&& this.mysteryBoxModalState
				&& this.cartProducts.length
				&& !this.isSubscribed;
		}
	},
	methods: {
		async getUserPreviousOrderItems(mysteryBoxProducts, voucherId) {
			try {
				const response = await MysteryBoxProvider.getMysteryBoxData({
					email: this.applicationUserLoggedIn ? this.customerDetails && this.customerDetails.email : "",
					mysteryBoxProducts,
					voucherId,
					shopId: this.globalSelectedShop.id,
					shopTimeZone: this.globalSelectedShop.shopTimeZone
				});
				return response && response.data;
			} catch (e) {
				return {};
			}
		},
		async getMysteryBoxProduct() {
			if(!this.checkMysteryBoxCriteria) {
				return null;
			}
			const priceRuleLabel = this.getMysteryBoxPriceRuleLabel;
			const priceRule = (this.priceRules || []).find((pr) => {
				const priceRuleChannelAvailability = !pr.options.channels
					|| !pr.options.channels.length
					|| pr.options.channels.includes(appConfig.channelAlias());
				return pr && pr.options.label === priceRuleLabel
					&& (pr.shopPattern || []).includes(this.globalSelectedShop.id)
					&& priceRuleChannelAvailability;
			});
			if(!priceRule || !["simpleDiscountFixedAmount", "percentDiscount"].includes(priceRule.discountType) || !priceRule.voucherPattern.length) {
				return null;
			}
			this.applicableMysteryBoxPriceRule = priceRule;
			const mysteryBoxProducts = ((priceRule && priceRule.productPattern) || []).filter(productId => {
				try {
					const product = this.productCatalog.getProduct(productId);
					// if product is not available on certain channel, it should be removed
					if(product.options.deliveryMethodIndex) {
						if(!product.options.deliveryMethodIndex.includes(this.tenantSpecificData.deliveryChoice)) {
							return false;
						}
					}
					const categoriesOfProduct = this.productCatalog.getAllCategoriesOfProduct(productId);
					const isProductCategoriesContainSelectedShop = categoriesOfProduct.some(
						(category) => Array.isArray(category.isSpecificForShops)
							&& category.isSpecificForShops.includes(this.globalSelectedShop.id)
					);
					const isProductSupportedByActiveChannel = !categoriesOfProduct.length || categoriesOfProduct
						.filter(category => !category.channels || category.channels.includes(appConfig.channelAlias()))
						.length;
					// this code covers using only products which are assigned to categories for specified channel
					if(!isProductSupportedByActiveChannel || !isProductCategoriesContainSelectedShop) {
						return false;
					}
					return canBePickedUp(
						product,
						this.productCatalog,
						this.$store.getters.cachedPickupRules,
						this.globalSelectedShop.id
					);
				} catch (e) {
					// should skip not available products in the shop
					return undefined;
				}
			})
				.filter(productId => {
					// product already in cart should not be shown in mystery box
					return !this.cartProducts.find(cartProduct => cartProduct.productId === productId);
				});
			if(!mysteryBoxProducts.length) {
				return null;
			}
			// special random act of kindness mystery box
			if(this.globalSelectedShop.shopOptions.enableMysteryBoxRandomActOfKindness) {
				this.sendingOrder = true;
				const {availableProductId, voucherVirtualOrderId} = await this.getUserPreviousOrderItems(
					mysteryBoxProducts,
					priceRule.voucherPattern[0]
				);
				if(!availableProductId || !voucherVirtualOrderId) {
					return null;
				}
				this.$store.commit(SET_VOUCHER_VIRTUAL_ORDER_ID, voucherVirtualOrderId);
				this.mysteryBoxProductId = availableProductId;
				this.sendingOrder = false;
				setTimeout(() => {
					if(!this.mysteryBoxModalState && !(this.selections || []).find(s => s.mysteryBoxAppliedVoucherId)) {
						this.closeMysteryBoxModal();
					}
				}, this.mysteryBoxSettings.mysteryBoxVoucherReleaseTimeout || 300000);
				this.$store.commit(mutationTypes.SET_MYSTERY_BOX_MODAL_STATE);
				return availableProductId;
			}
			// regular mystery box
			const mysteryBoxProductId = mysteryBoxProducts[generateRandomNumber(mysteryBoxProducts.length)];
			if(mysteryBoxProductId) {
				this.mysteryBoxProductId = mysteryBoxProductId;
				return mysteryBoxProductId;
			}
			return null;
		}
	}
};
